import banner from '../assets/images/banner_creation_bg.png';
import flipTreeContent from '../assets/images/fliptree_digital_cnt.png';
import fbIcon from '../assets/images/fb_icon.png';
import instagramIcon from '../assets/images/instagram_icon.png';
import linkedInIcon from '../assets/images/linkedin_icon.png';
import youtubeIcon from '../assets/images/youtube_icon.png';
import whatsappIcon from '../assets/images/whatsapp_icon.png';

export const bannerCreationPopup = {
    "company_info": {
        'banner_bg': banner,
        "digital_cnt": flipTreeContent,
        "tagline": "We turn ideas into impact",
        "description": "We are a full-scale advertising agency with an in-house media, graphic, and production studio. We provide the creative fuel to help clients across the globe take their business to the next level. Specializing in digital marketing, brand building, social media, creatives, and marketing strategy. Let us manage your brand while you focus on growing your business.",
        "website": "https://www.fliptreeigital.com",
        "contact": {
            "phone": {
                "title": "Contact No: ",
                "number": "7356607063",
                "formatted": "+91 7356607063"
            },
            "email": {
                "title": "Email: ",
                'mail': 'hello@fliptreedigital.com'
            }
        },
        "special_offer": "Get Special Offers for Lumi Ad Banners"
    },
    "social_media_icons": [{
            "platform": "Facebook",
            "icon": fbIcon,
            "url": "https://www.facebook.com/fliptreedigital/"
        },
        {
            "platform": "Instagram",
            "icon": instagramIcon,
            "url": "https://www.instagram.com/fliptreedigital/"
        },
        {
            "platform": "LinkedIn",
            "icon": linkedInIcon,
            "url": "https://www.linkedin.com/company/fliptree-digital/"
        },
        {
            "platform": "YouTube",
            "icon": youtubeIcon,
            "url": "https://www.youtube.com/@fliptreedigital"
        },
        {
            "platform": "WhatsApp",
            "icon":whatsappIcon,
            "url": "http://wa.me/917356607063"
        }
    ],
}